export default __webpack_public_path__ + "static/1664-8a1cc435352cc744d0f385f55629a36f.gif";